import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

const LeftWing = ({ mainTopBannerVisible }) => {
    const [top, setTop] = useState(0)
    const [position, setPosition] = useState('absolute')
    const [display, setDisplay] = useState('none')
    const [fixTop, setFixTop] = useState(90) // fixed시 높이값

    const [initPositon, setInitPositon] = useState(333) // 기본 높이값
    const [flag, setFlag] = useState(245)  // position 전환점
    const headerHeight = mainTopBannerVisible ? 277 : 197 // header 높이값
    const maxPosition = 323 // 하단 브레이크 위치 (하단에서 부터의 높이)
    const wingHeight = 514 // 레이어 높이
    const isMain = window.isMainDisplay // 메인확인 전역변수
    let domain = window.location.hostname.split('.')[0] // 도메인


    useEffect(() => {
        scroll()
        window.addEventListener('scroll', scroll)

        return () => {
            window.removeEventListener('scroll', scroll)
        }
    }, [initPositon, flag])

    useEffect(() => {
        init()
        window.addEventListener('onSetWingLocation', init)
        return () => {
            window.removeEventListener('onSetWingLocation', init)
        }
    }, [mainTopBannerVisible])


    const init = () => {
        const header = document.querySelector('#header')
        if (isMain) {
            const position = headerHeight + 554
            setInitPositon(headerHeight + 554)
            setFlag(position - fixTop)
            setTop(position)
        } else if (domain === 'deal') {
            if (window.location.pathname === '/') {
                const position = headerHeight + 374
                setInitPositon(position)
                setFlag(position - fixTop)
                setTop(position)
            } else {
                const position = headerHeight + 66
                setInitPositon(position)
                setFlag(position - fixTop)
                setTop(position)
            }
        } else if (domain === 'shopping') {
            if (window.location.pathname.split('/')[1] === 'detail') {
                const position = headerHeight + 56
                const fix = fixTop + 60
                setInitPositon(position)
                setFixTop(fix)
                setFlag(position - fix)
                setTop(position)
            }
        } else if (window.isStdpc) {
            const position = headerHeight + 9
            setInitPositon(position)
            setFlag(position - fixTop)
            setTop(position)
        } else if (header) {
            const position = headerHeight + 56
            setInitPositon(position)
            setFlag(position - fixTop)
            setTop(position)
        } else {
            setFlag(245)
            setInitPositon(333)
            setTop(initPositon)
        }
        setDisplay('block')
    }

    const scroll = () => {
        const scrollTop = window.scrollY || window.pageYOffset
        if (scrollTop > flag) {
            setTop(fixTop)
            setPosition('fixed')

            const bodyHeight = document.body.offsetHeight
            if (bodyHeight - fixTop - maxPosition - wingHeight < scrollTop) {
                const top = bodyHeight - scrollTop - maxPosition - wingHeight
                setTop(top)
            }
        } else {
            setTop(initPositon)
            setPosition('absolute')
        }
    }

    return (
        window.isStdpc ? (
            <Wing className="layout_left_wing" style={{ display, top, position }}>
                <div>
                    <ul>
                        <li>
                            <a
                                href={process.env.REACT_APP_STDPC_URL + '/list/2040000000'}
                                // target="_blank"
                                rel="noopener noreferrer">
                                <img src={process.env.REACT_APP_CDN_IMG + '/img_static/img/stdpc/sidewing/intel.jpg'} alt=""></img>
                            </a>
                        </li>
                        <li style={{ marginTop: '10px' }}>
                            <a
                                href={process.env.REACT_APP_STDPC_URL + '/list/2040000000'}
                                // target="_blank"
                                rel="noopener noreferrer">
                                <img src={process.env.REACT_APP_CDN_IMG + '/img_static/img/stdpc/sidewing/amd.jpg'} alt=""></img>
                            </a>
                        </li>
                    </ul>
                </div>
            </Wing>
        ) : (
            // 메인) 무이자24 페이지 이동 수정
            mainTopBannerVisible && (
                <Wing className="layout_left_wing" mainTopBannerVisible={mainTopBannerVisible}>
                    <div>
                        <ul>
                            <li>
                                <a
                                    target={'_blank'}
                                    href={process.env.REACT_APP_STDPC_URL + '/list/2040000000'}
                                    // target="_blank"
                                    rel="noopener noreferrer">
                                    <img src={process.env.REACT_APP_CDN_IMG + '/img_static/img/stdpc/sidewing/intel.jpg'} alt=""></img>
                                </a>
                            </li>
                            <li style={{ marginTop: '10px' }}>
                                <a
                                    target={'_blank'}
                                    href={process.env.REACT_APP_STDPC_URL + '/list/2040000000'}
                                    // target="_blank"
                                    rel="noopener noreferrer">
                                    <img src={process.env.REACT_APP_CDN_IMG + '/img_static/img/stdpc/sidewing/amd.jpg'} alt=""></img>
                                </a>
                            </li>
                        </ul>
                    </div>
                </Wing>
            )
        )
    )
}

const Wing = styled.div`
    position: absolute;
    top: ${(props) => props.mainTopBannerVisible ? 285 : 300}px;
    margin-right: ${(props) => props.mainTopBannerVisible ? 605 : 485}px;
    right: 50%;   
    z-index: 100;

    @media only screen and (max-width: 1280px) {
        display: none!important;
   }
`
export default LeftWing



// WEBPACK FOOTER //
// ./src/header/component/leftwing.js